import React, { useContext, useState } from "react";
import { BiDetail } from "react-icons/bi";
import { FaLock } from "react-icons/fa";
import { Context } from "../../context";
import classes from "./Demo.module.css";

const DemoCard2 = ({
  id,
  title_it,
  title_en,
  img,
  url,
  description_it,
  description_en,
  viewDemo,
  setLogin,
  viewInfo,
  info,
  setInfo,
  setViewInfo,
  selectedCard,
  openPopupCard,
  lock,
}) => {
  const parse = require("html-react-parser");
  const { debug, lang } = useContext(Context);
  const [isVisible, setIsVisible] = useState(false);
  const [selectedTab, setSelectedTab] = useState("description");

  const changeVisibility = (isVisibleSensor) => {
    if (isVisibleSensor && isVisible === false) {
      setIsVisible(true);
    }
  };

  return (
    <div className="col-md-6 my-1">
      <div className={`${classes.cardWrapper} mb-5`}>
        <div
          key={"democard" + id}
          style={{ overflow: "hidden" }}
          className={classes.openedCard2}
        >
          {/* BASH HEADER */}
          <div className={classes.titleBarLight}>
            <div className={classes.dots}>
              <div className={`${classes.dot} ${classes.dotRed}`}></div>
              <div className={`${classes.dot} ${classes.dotYellow}`}></div>
              <div className={`${classes.dot} ${classes.dotGreen}`}></div>
            </div>
            <div className={classes.tabLight}>
              {lang === "en" ? title_en : title_it}.js
            </div>
          </div>

          <div className={classes.demoCardBody}>
            <img src={img} alt={title_en} className={classes.demoCard2} />

            <div className={`${classes.textCard} d-flex flex-column`}>
              <div>
                <div className={classes.titleCard}>
                  {lang === "en" && title_en}
                  {lang === "it" && title_it}
                </div>
                <div className={classes.descriptionCard}>
                  {lang === "en" && description_en}
                  {lang === "it" && description_it}
                </div>
              </div>

              <div className={`${classes.flexButtons} mt-2 w-100 d-flex justify-content-between`}>
                {viewInfo && (
                  <div
                    className={`${classes.demoCard2Button}`}
                    onClick={() => {
                      setViewInfo(true);
                      setInfo(id);
                    }}
                  >
                    <button
                      type="button"
                      className={`${classes.detailsButton}`}
                    >
                      <BiDetail className={classes.detailsIcon} />
                      Info
                    </button>
                  </div>
                )}

                {viewDemo || !lock ? (
                  <div className={`${classes.demoCard2Button}`}>
                    <a
                      href={
                        url.startsWith("http") ? url : `https://${url}`
                      }
                      target="_blank"
                    >
                      <button
                        type="button"
                        className={`${classes.detailsButton}`}
                      >
                        <BiDetail className={classes.detailsIcon} />
                        {lang === "en" && <>Demo access</>}
                        {lang === "it" && <>Accesso demo</>}
                      </button>
                    </a>
                  </div>
                ) : (
                  <>
                    {" "}
                    <div
                      className={`${classes.demoCard2Button}`}
                      onClick={() => {
                        setLogin(true);
                      }}
                    >
                      <button
                        type="button"
                        className={`${classes.detailsButton}`}
                      >
                        <FaLock className={classes.lockIcon} />
                        {lang === "en" && <>Demo access</>}
                        {lang === "it" && <>Accesso demo</>}
                      </button>
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DemoCard2;
